import store from '../store';
import { EventBus } from '../api/eventbus';

export default class Manager {
    /**
     *
     */
    constructor({ name, id, description, shop, icon }) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.shop = shop;
        this.costs = 0;
        this.isHired = false;
        this.icon = icon;
        this.isAvailable = true;
    }

    hire() {
        let shop = store.getters.getShopByID(this.shop);
        if (typeof shop !== 'undefined' && this.costs.lte(store.getters.totalBalance)) {
            store.commit('DECREASE_BALANCE', { amount: this.costs });
            store.commit('SET_MANAGER', { manager: this, shop });
            this.isHired = true;
            EventBus.$emit('playSound', 'coins');
            if (shop.id === 'LemonadeStand' && store.state.tutorial.step.id === 9) {
                store.dispatch('setStep', 10);
            }
            return true;
        }
        return false;
    }

    /**
     * @param loaded
     */
    merge(loaded) {
        this.isHired = loaded.isHired;
    }
}
